import axios from 'axios';
import { ICatFilters } from '../../redux/state/mcatalogueState';
import { mcatalogueFields } from '../../util/mcatalogue/mcatalogueFields';

export const fetchCatalogues = (limit: number = 50, offset: number = 0, order: string, orient: string = "asc", filters: ICatFilters) => {
    let url = `/api/v1/products?term[productType]=1,2&source=cp&isDeleted=0&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}`;

    for (let key in filters) {
        if (key == "mainSearch" || key == "cp_user_id") {
            continue;
        }
        if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'inhouseId')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'categoryName')) {
            url += `&term[categoryName]=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'productName')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'productId')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && filters[key] && !Array.isArray(filters[key]) && (['inhouseId', "productName", "productId"].indexOf(key) === -1)) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && Array.isArray(filters[key]) && filters[key].filter(f => f !== '').length > 0) {
            url += `&${key}=[${filters[key]}]`
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    if (filters["mainSearch"] != "") {
        url += `&search=${filters["mainSearch"]}`;
    }
    return axios.get(url);
};
export const fetchCatalogue = (id, account_id) => {
    if (account_id) {
        let url = `/api/v1/products/` + id + `?source=cp&account_id=` + account_id;

        return axios.get(url);
    } else {
        let url = `/api/v1/products/` + id + `?source=cp`;

        return axios.get(url);
    }
};
export const fetchCatalogueCategories = () => {
    let url = `/api/v1/products/categories`;
    return axios.get(url);
};
export const createOrder = (data) => {
    let url = `/api/v1/orders`;

    return axios.post(url, data);
};
export const updateRowItem = (qid, id, data) => {
    let url = `/api/v1/orders/` + qid + `/items/` + id + `/rows/` + data.id;
    return axios.put(url, data);
};
export const fetchDecorationLocations = () => {
    let url = `/api/v1/decorations/locations`;

    return axios.get(url);
};
export const fetchDecorationTypes = () => {
    let url = `/api/v1/decorations/types?limit=100`;

    return axios.get(url);
};
export const createOrderItemRowDecoration = (data, id, itemid, rowid) => {
    let url = `/api/v1/orders/` + id + `/items/` + itemid + `/rows/` + rowid + `/decorations`;

    return axios.post(url, data);
};
export const createOrderItem = (data, id) => {
    let url = `/api/v1/orders/` + id + `/items`;

    return axios.post(url, data);
};
export const createOrderItemRow = (data, id, itemid) => {
    let url = `/api/v1/orders/` + id + `/items/` + itemid + `/rows`;

    return axios.post(url, data);
};
export const fetchArtworks = (filterData) => {
    let url = `/api/v1/artwork?source=cp&termIn[statusName][]=Done&term[isInactive]=0`;
    if (filterData.accountId) {
        url += `&account_id=${filterData.accountId}`;
    }
    if (filterData.contactId) {
        url += `&term[contact_id]=${filterData.contactId}`;
    }
    return axios.get(url);
};
export const fetchArtworkdetail = (id) => {
    let url = `/api/v1/artwork/` + id;

    return axios.get(url);
};
export const getDecoratorTypes = () => {
    let url = `/content/get-decorator-types-all/`;

    return axios.get(url);
};
export const getDecoratorVendors = () => {
    let url = `/content/get-decorator-vendors`;

    return axios.get(url);
};
export const createArtwork = (data) => {
    let url = `/api/v1/artwork`;

    return axios.post(url, data);
};
